import { CALL_API } from '../middleware/ApiMiddleware';

export const GET_SSO_CONFIG_REQUEST = 'GET_SSO_CONFIG_REQUEST';
export const GET_SSO_CONFIG_SUCCESS = 'GET_SSO_CONFIG_SUCCESS';
export const GET_SSO_CONFIG_FAILURE = 'GET_SSO_CONFIG_FAILURE';

export const GET_SSO_TOKEN_REQUEST = 'GET_SSO_TOKEN_REQUEST';
export const GET_SSO_TOKEN_SUCCESS = 'GET_SSO_TOKEN_SUCCESS';
export const GET_SSO_TOKEN_FAILURE = 'GET_SSO_TOKEN_FAILURE';

export const GET_SSO_USER_INFO_REQUEST = 'GET_SSO_USER_INFO_REQUEST';
export const GET_SSO_USER_INFO_SUCCESS = 'GET_SSO_USER_INFO_SUCCESS';
export const GET_SSO_USER_INFO_FAILURE = 'GET_SSO_USER_INFO_FAILURE';

const crmTokenSSOBaseURL = 'crm';

export const getSSOConfig = (crmToken: string) => ({
  [CALL_API]: {
    endpoint: `${crmTokenSSOBaseURL}/${crmToken}/sso/config`,
    method: 'get',
    authenticated: false,
    types: [GET_SSO_CONFIG_REQUEST, GET_SSO_CONFIG_SUCCESS, GET_SSO_CONFIG_FAILURE],
  },
});

export const getSSOToken = (crmToken: string, authCode: string) => ({
  [CALL_API]: {
    endpoint: `${crmTokenSSOBaseURL}/${crmToken}/sso/idp-token`,
    method: 'get',
    authenticated: false,
    params: { code: authCode },
    types: [GET_SSO_TOKEN_REQUEST, GET_SSO_TOKEN_SUCCESS, GET_SSO_TOKEN_FAILURE],
  },
});

export const getSSOUserInfo = (crmToken: string, idpUserInfoRequest: ISsoUserInfoRequest) => ({
  [CALL_API]: {
    endpoint: `${crmTokenSSOBaseURL}/${crmToken}/sso/user-info`,
    method: 'post',
    body: idpUserInfoRequest,
    authenticated: false,
    types: [GET_SSO_USER_INFO_REQUEST, GET_SSO_USER_INFO_SUCCESS, GET_SSO_USER_INFO_FAILURE],
  },
});
